const ChannelTemplate = require('./ChannelTemplate/BaseChannelTemplate');

const EmailChannelTemplate = require('./ChannelTemplate/EmailChannelTemplate');
const SMSChannelTemplate = require('./ChannelTemplate/SMSChannelTemplate');
const WhatsappChannelTemplate = require('./ChannelTemplate/WhatsappChannelTemplate');

ChannelTemplate.Email = EmailChannelTemplate;
ChannelTemplate.SMS = SMSChannelTemplate;
ChannelTemplate.Whatsapp = WhatsappChannelTemplate;

module.exports = ChannelTemplate;
